var map = {
	"./Cabecalho_Carta_Proposta.png": 3378,
	"./Cabecalho_Carta_Proposta.svg": 3938,
	"./Cabecalho_Carta_Proposta_1_PNG.png": 2929,
	"./Cabecalho_Orcamento.svg": 7667,
	"./Cabecalho_PDF_CartaProposta.svg": 9132,
	"./Cabecalho_PDF_CartaProposta_PNG.png": 3354,
	"./Cabecalho_PDF_Pedido.svg": 5990,
	"./Fundo_login_1.svg": 3819,
	"./Fundo_login_2.svg": 5148,
	"./IconTotalGanho.svg": 6809,
	"./IconTotalGanhoEscuro.svg": 1885,
	"./Icon_Filtrar.svg": 3970,
	"./IconeCaneta.svg": 5376,
	"./Icone_Agenda.svg": 5695,
	"./Icone_Atualizar_Lista.svg": 7486,
	"./Icone_Condicoes_Pagto.svg": 9520,
	"./Icone_Excel.svg": 3243,
	"./Icone_Imagem_Produto.svg": 2358,
	"./Ilustra_sem_imagem.svg": 5119,
	"./Ilustracao_Nenhuma_Img.svg": 8801,
	"./Ilustracao_erro.svg": 9178,
	"./Imagem_login.png": 2067,
	"./Logo_JauenseEmbalagens.png": 3195,
	"./Logo_JauenseNordeste.png": 1381,
	"./Logo_Suprema.png": 2017,
	"./Manutencao.svg": 6874,
	"./Rodape_CartaProposta.svg": 8161,
	"./Rodape_CartaProposta_PNG.png": 7720,
	"./Rodape_Orcamento.svg": 8160,
	"./Rodape_Orcamento_inicio.svg": 5723,
	"./Rodape_Orcamento_inicio_PNG.png": 6899,
	"./Sem_Acesso.svg": 7972,
	"./angle-left-solid.svg": 2164,
	"./angles-left-solid.svg": 4769,
	"./caixa.png": 9468,
	"./checkprancheta.svg": 8302,
	"./down-long-solid.svg": 3600,
	"./fundo_retangulos.svg": 5651,
	"./fundo_retangulos_baixo.svg": 7145,
	"./grupo_jauense_logo.svg": 9341,
	"./grupo_jauense_logo_sidebar.svg": 7621,
	"./icon_expandir_amarelo.svg": 855,
	"./icon_seta_azul.svg": 7792,
	"./icone_Resumo.svg": 8298,
	"./icone_add.svg": 9538,
	"./icone_add_telefone.svg": 3326,
	"./icone_adicionar_ob.svg": 8777,
	"./icone_ag_motivos_perdas.svg": 5882,
	"./icone_atencao.svg": 228,
	"./icone_atualizar.svg": 7338,
	"./icone_calendario.svg": 5991,
	"./icone_caminhao.svg": 8776,
	"./icone_carta_menor.svg": 5489,
	"./icone_carta_proposta.svg": 5083,
	"./icone_coluans.svg": 5393,
	"./icone_compartilhar.svg": 7745,
	"./icone_componente_orcamento.svg": 828,
	"./icone_continuar.svg": 8332,
	"./icone_doc.svg": 6462,
	"./icone_docs.svg": 8465,
	"./icone_editar.svg": 5616,
	"./icone_fechar_menu.svg": 1776,
	"./icone_filtro.svg": 3826,
	"./icone_frete_orcamento.svg": 4535,
	"./icone_historico.svg": 3736,
	"./icone_imprimir.svg": 8250,
	"./icone_lixo.svg": 4961,
	"./icone_lixo_cinza.svg": 1332,
	"./icone_lupa.svg": 5421,
	"./icone_orc_produto.svg": 5852,
	"./icone_orçamento_menor.svg": 4846,
	"./icone_orçamentos.svg": 3054,
	"./icone_pagamento.svg": 5322,
	"./icone_pagamentos.svg": 8540,
	"./icone_parametros.svg": 4172,
	"./icone_pedidos_andamento.svg": 3601,
	"./icone_pedidos_cancelados.svg": 7594,
	"./icone_pedidos_concluidos.svg": 4220,
	"./icone_pedidos_pendentes.svg": 5407,
	"./icone_print.svg": 8684,
	"./icone_reorcar.svg": 5149,
	"./icone_resumo_barra.svg": 727,
	"./icone_seta.svg": 7863,
	"./icone_seta_marrom.svg": 189,
	"./icone_sete_volta.svg": 5845,
	"./icone_share.svg": 8981,
	"./icone_valor.svg": 1739,
	"./icone_viavel.svg": 2335,
	"./icone_voltar.svg": 5214,
	"./ilustra_ajuda.svg": 6532,
	"./logo_abigraf.svg": 1806,
	"./reorcar.svg": 7668,
	"./search.svg": 7302,
	"./teste.png": 8351,
	"./up-long-solid.svg": 6544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4040;